import { useCallback, useMemo } from 'react';
import { values, map, reduce, toNumber } from 'lodash-es';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useTranslate } from '@tolgee/react';
import dayjs from 'lib/dayjs';

const reasons = {
  广告骚扰: {
    'zh-CN': '广告骚扰',
    'en-US': 'Advertising harassment',
    es: 'Advertising harassment',
    tl: 'Inaadvertise ang harassment',
    th: 'การล่วงละเมิดโฆษณา',
    id: 'Spam Promosi',
    vi: 'Quảng cáo rác',
    pt: 'Assédio publicitário',
  },
  其他: {
    'zh-CN': '其他',
    'en-US': 'Other',
    es: 'Other',
    tl: 'Other',
    th: 'อย่างอื่น',
    id: 'Lainnya',
    vi: 'Khác',
    pt: 'Outro',
  },
};

const reasonsMeta = reduce(
  values(reasons),
  (acc, reason) => {
    values(reason).forEach((value) => {
      acc[value] = reason;
    });
    return acc;
  },
  {} as any,
);

export const useOfficialReasonList = () => {
  const lang = useSystemLanguageValue();
  return useMemo(() => {
    return map(values(reasons), (reason) => reason[lang]);
  }, [lang]);
};

export const useGetMetaReason = () => {
  const lang = useSystemLanguageValue();
  return useCallback(
    (reason: string) => {
      return reasonsMeta?.[reason]?.[lang] || reason;
    },
    [lang],
  );
};

export const useReplaceReason = () => {
  const lang = useSystemLanguageValue();
  const { t } = useTranslate();

  return useCallback(
    (enSource: string, sendTime: string | number) => {
      const name = enSource.split(' ')[0];
      if (enSource.includes('has blocked buyer at')) {
        // 拉黑
        const keys = Object.keys(reasonsMeta);
        const found = keys.find((key) => enSource.includes(key));
        const defaultCause = enSource.split('cause')[1];
        return t('system.msg.add.blacklist', {
          name,
          time: dayjs(toNumber(sendTime)).format('YYYY-MM-DD HH:mm:ss'),
          cause: found ? reasonsMeta[found][lang] : defaultCause,
        });
      }
      if (enSource.includes('has removed buyer from block list at')) {
        // 取消拉黑
        return t('system.msg.remove.blacklist', {
          name,
          time: dayjs(toNumber(sendTime)).format('YYYY-MM-DD HH:mm:ss'),
        });
      }
    },
    [lang, t],
  );
};
